import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import TitleHero from "../components/Hero/TitleHero";

const Thankyou = () => {
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1); // Navigates to the previous page
    };

    useEffect(()=> {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      },[]);

    return (
        <>
            <TitleHero title="THANK YOU" />
            <div className="container bg-light"  >
                <p className="mb-2 mb-lg-4 px-0 btn btn-link" onClick={goBack}>Go to previous page</p>
                <div className="row row-cols-1 row-cols-lg-2 my-5">
                    <div className="col">

                        <div className="thankyou-content">
                            <h1 className="text-dark fw-bold display-5">Thanks for your request</h1>
                            <p className="">We’ll be in touch soon to schedule your live product demo.</p>
                            <p className="fw-bold lh-0 mb-0">See our platform in action</p>
                            <p>Get a preview of the top Shoora features.</p>
                            <button className="btn btn-dark rounded-5" onClick={goBack}>Watch the videos</button>
                        </div>
                    </div>
                    <div className="col mt-5 mt-lg-0">
                        <img src="https://assets.verizonconnect.com/cdn-cgi/image/width=1112,height=660,format=auto/thank-you/us-thankyou.png" alt="Shoora Platform" className="w-100" />
                    </div>
                </div>
            </div>
        </>
    );
};



export default Thankyou;
